import { render, staticRenderFns } from "./GalleryHotspots.vue?vue&type=template&id=523f0dc0&scoped=true&"
import script from "./GalleryHotspots.vue?vue&type=script&lang=ts&"
export * from "./GalleryHotspots.vue?vue&type=script&lang=ts&"
import style0 from "./GalleryHotspots.vue?vue&type=style&index=0&id=523f0dc0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523f0dc0",
  null
  
)

export default component.exports